import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';
import ViewOtherOpportunitiesButton from './ViewOtherOpportunitiesButton';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';

const TopBar = ({
    title,
    description,
    isAuthorized = false,
    openOtherOpportunitiesPage,
    showActiveOpportunities,
    showAppNudge,
}) => {
    return (
        <div className="flex flex-col w-full md:flex-row md:justify-between">
            <div
                className={cn(
                    'flex flex-col gap-3 pt-6 pb-4 mx-auto text-center md:gap-2 max-w-[305px] md:max-w-none md:mx-0 md:text-left',
                    {
                        'lg:py-8': isAuthorized,
                        'md:py-8': !isAuthorized,
                        'md:py-4 lg:pb-4': isAuthorized && showAppNudge,
                    }
                )}
            >
                <Text
                    content={title}
                    className="text-basicWhite h5-semibold md:h4-semibold"
                />
                <Text
                    content={description}
                    className="text-gray-200 p5-regular"
                />
            </div>
            {showAppNudge ? (
                <ViewOtherOpportunitiesButton
                    buttonSize={buttonSizes.SMALL}
                    buttonType={buttonTypes.TEXT}
                    className="!text-basicWhite hover:!text-basicWhite/90 hidden lg:inline-flex"
                    openOtherOpportunitiesPage={openOtherOpportunitiesPage}
                    showActiveOpportunities={showActiveOpportunities}
                />
            ) : null}
        </div>
    );
};

export default TopBar;
